export default __webpack_public_path__ + "static/media/in-or.b7d04d8c.svg";